import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { logout, signIn } from "../../../core/data/redux/auth/authAction"; // Import the signIn action
import { AppDispatch } from "../../../core/data/redux/store";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup"; // For validation schema
import { message, Modal } from "antd";
import { getUserMenuPermissions } from "../../../core/data/redux/user/rolePermission/rolePermissionAction";

type PasswordField = "password";

const Login = () => {
  // const routes = all_routes;
  // const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  // const [showRenewModal, setShowRenewModal] = useState(false);
  // const [pendingNavigation, setPendingNavigation] = useState(false);
  // const { userMenuPermissions } = useSelector((state: any) => state.rolePermission);

  const { signInLoading } = useSelector((state: any) => state.auth);

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  const [rememberMe, setRememberMe] = useState(false);

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  // Redirect to dashboard after successful login
  // useEffect(() => {
  //   if (token && userMenuPermissions) {
  //     const isAdminAllowed = Object.keys(userMenuPermissions?.menuPermissions || {}).includes("Admin Dashboard");
  //     navigate(isAdminAllowed ? routes.adminDashboard : routes.employeeDashboard);
  //   }
  // }, [token, navigate, routes.adminDashboard, routes.employeeDashboard, userMenuPermissions]);

  // Formik validation schema
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email address").required("Email is required"),
    password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
    subscription_id: Yup.string()
    .matches(/^\d+$/, "Subscription ID must be numeric")
    .required("Subscription ID is required"),
  });

  // Check localStorage for saved credentials and Remember Me state
  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    const savedPassword = localStorage.getItem("password");
    const savedSubscriptionId = localStorage.getItem("subscription_id");
    const savedRememberMe = localStorage.getItem("rememberMe") === "true"; // Get the state of Remember Me from localStorage

    if (savedEmail && savedPassword && savedSubscriptionId) {
      setRememberMe(savedRememberMe); // Set Remember Me state based on localStorage
    }
  }, []);

  const handleSubmit = async (values: { email: string; password: string; subscription_id: string }) => {
    try {
      const response = await dispatch(
        signIn({
          email: values.email,
          password: values.password,
          subscription_id: values.subscription_id,
          configID: "2",
        })
      );
  
      if (signIn.fulfilled.match(response)) {
        const data: any = response.payload.data;
  
        // Store session ID
        localStorage.setItem("session_id", data.session_id);
  
        // Handle remember me
        if (rememberMe) {
          localStorage.setItem("email", values.email);
          localStorage.setItem("password", btoa(values.password));
          localStorage.setItem("subscription_id", values.subscription_id);
          localStorage.setItem("configID", "2");
          localStorage.setItem("rememberMe", "true");
        } else {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
          localStorage.removeItem("subscription_id");
          localStorage.removeItem("configID");
          localStorage.removeItem("rememberMe");
        }
  
        // Get permissions
        const permissionsResponse:any = await dispatch(getUserMenuPermissions());
        const menuPermissions = permissionsResponse?.payload?.data?.menuPermissions || {};
        const isAdminAllowed = Object.keys(menuPermissions).includes("Admin Dashboard");
        console.log("data",data)
        // Subscription warning
        if (data?.checkRenewStatus) {
          Modal.warning({
            title: 'Subscription Warning',
            content: data?.configError,
            okText: 'OK',
            onOk: () => {
              window.location.href = isAdminAllowed
                ? all_routes.adminDashboard
                : all_routes.employeeDashboard;
            },
          });
          return;
        }
  
        message.success("Login successful!");
        window.location.href = isAdminAllowed
          ? all_routes.adminDashboard
          : all_routes.employeeDashboard;
  
      } else {
        // Handle login errors
        const errorMessage = response?.payload || "Login failed. Please try again.";
        if (errorMessage === "Another active session is detected.") {
          Modal.confirm({
            title: "Active Session Detected",
            content: "You're already logged in on another device. Do you want to logout from the other session?",
            okText: "Logout Other Session",
            cancelText: "Cancel",
            onOk: async () => {
              const logoutResponse: any = await dispatch(logout(values.email));
              if (logout.fulfilled.match(logoutResponse)) {
                message.success("Logged out from previous session. Trying login again...");
                handleSubmit(values); // Retry login
              } else {
                message.error("Failed to logout previous session.");
              }
            },
          });
        } else {
          message.error(`Login failed: ${errorMessage}`);
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      message.error("Unexpected error during login.");
    }
  };
  


  const handleRememberMeChange = () => {
    const newRememberMe = !rememberMe;
    setRememberMe(newRememberMe);
    localStorage.setItem("rememberMe", newRememberMe.toString()); // Save the state of the checkbox in localStorage
  };

  // Clear local storage on logout
  // const handleLogout = () => {
  //   localStorage.removeItem("email");
  //   localStorage.removeItem("password");
  //   localStorage.removeItem("subscription_id");
  //   localStorage.removeItem("configID");
  //   localStorage.removeItem("rememberMe");
  // };

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
              <div className="bg-overlay-img">
                <ImageWithBasePath src="assets/img/bg/bg-01.png" className="bg-1" alt="Img" />
                <ImageWithBasePath src="assets/img/bg/bg-02.png" className="bg-2" alt="Img" />
                <ImageWithBasePath src="assets/img/bg/bg-03.png" className="bg-3" alt="Img" />
              </div>
              <div className="authentication-card w-100">
                <div className="authen-overlay-item border w-100">
                  <h1 className="text-white display-1">
                    Empowering people <br /> through seamless HR <br /> management.
                  </h1>
                  <div className="my-4 mx-auto authen-overlay-img">
                    <ImageWithBasePath src="assets/img/bg/authentication-bg-001.svg" alt="Img" />
                  </div>
                  <div>
                    <p className="text-white fs-20 fw-semibold text-center">
                      Efficiently manage your workforce, streamline <br />{" "}
                      operations effortlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
              <div className="col-md-7 mx-auto vh-100">
                <Formik
                  initialValues={{
                    email: localStorage.getItem("email") || "",
                    password: localStorage.getItem("password") ? atob(localStorage.getItem("password")!) : "",
                    subscription_id: localStorage.getItem("subscription_id") || "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ touched, errors, isSubmitting }) => (
                    <Form className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                      <div className=" mx-auto mb-5 text-center">
                        <ImageWithBasePath
                          src="assets/img/hrmlogo24.svg"
                          className="img-fluid"
                          alt="Logo"
                          style={{ width: '180  px', height: 'auto', marginLeft: '' }}
                        />
                      </div>
                      <div className="">
                        <div className="text-center mb-3">
                          <h2 className="mb-2">Sign In</h2>
                          <p className="mb-0">Please enter your details to sign in</p>
                        </div>

                        {/* Subscription ID */}
                        <div className="mb-3">
                          <label className="form-label">Subscription Id</label>
                          <div className="input-group">
                            <Field
                              type="text"
                              name="subscription_id"
                              className="form-control border-end-0"
                            />
                          </div>
                          <ErrorMessage
                            name="subscription_id"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Email */}
                        <div className="mb-3">
                          <label className="form-label">Email Address</label>
                          <div className="input-group">
                            <Field
                              type="text"
                              name="email"
                              className="form-control border-end-0"
                            />
                          </div>

                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Password */}
                        <div className="mb-3">
                          <label className="form-label">Password</label>
                          <div className="pass-group">
                            <Field
                              type={passwordVisibility.password ? "text" : "password"}
                              name="password"
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.password ? "ti-eye" : "ti-eye-off"}`}
                              onClick={() => togglePasswordVisibility("password")}
                            ></span>
                          </div>
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Remember me and Forgot password link */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <div className="form-check form-check-md mb-0">
                              <input
                                className="form-check-input"
                                id="remember_me"
                                type="checkbox"
                                checked={rememberMe}
                                onChange={handleRememberMeChange} // Use the handleRememberMeChange method here
                              />
                              <label
                                htmlFor="remember_me"
                                className="form-check-label mt-0"
                              >
                                Remember Me
                              </label>
                            </div>
                          </div>
                          <div className="text-end">
                            <Link to={all_routes.forgotPassword} className="link-danger">
                              Forgot Password?
                            </Link>
                          </div>
                        </div>

                        {/* Sign In Button */}
                        <div className="mb-3">
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={isSubmitting || signInLoading}
                          >
                            {signInLoading ? "Signing In..." : "Sign In"}
                          </button>
                        </div>

                          {/* href="https://register.hrmtree.com/?productId=12" */}

                        {/* Register link */}
                        <div className="text-center">
                          <h6 className="fw-normal text-dark mb-0">
                            Don’t have an account?
                            <a
                              href="https://register.hrmtree.com/?productId=12"
                              rel="noopener noreferrer"
                              className="hover-a"
                            >
                              Create Account
                            </a>
                          </h6>
                        </div>
                      </div>

                      {/* Footer */}
                      <div className="mt-5 pb-4 text-center">
                        <p className="mb-0 text-gray-9">Copyright © 2025 - hrmtree</p>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
